export const styles = {
  margin: {
    marginTop: 15,
    marginBottom: 15,
  },
  containerCards: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 15,
    marginBottom: 20,
  },
  viewCharts: {
    display: 'flex',
    flexWrap: 'nowrap',
    marginTop: 15,
  },
  containerChart: {
    minWidth: '25%',
    border: 'solid 1px #d3d3d3',
    padding: 10,
    margin: '0 10px 10px 0',
  },
  containerChartDonut: {
    width: '50%',
    border: 'solid 1px #d3d3d3',
    padding: 10,
    margin: '0 10px 10px 0',
  },
  card: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  containerChartLine: {
    width: '75%',
    border: 'solid 1px #d3d3d3',
    padding: 10,
    marginTop: 20,
  },
  containerChartTable: {
    width: '75%',
    padding: 10,
    marginTop: 20,
  },
  containerChartf: {
    minWidth: '25%',
    width: '40%',
    border: 'solid 1px #d3d3d3',
    marginTop: 20,
    marginBottom: 20,
    padding: 10,
  },
  title: {textAlign: 'center', marginTop: 10, marginBottom: 10},
  flex: {width: '100%', display: 'flex', justifyContent: 'space-between'},
  flexEnd: {width: '100%', display: 'flex', justifyContent: 'flex-end'},
  datePicker: {
    borderRadius: '40px',
    height: 50,
    width: 'fit-content',
    border: 'solid 1px #d3d3d3',
    marginBottom: 20,
    marginLeft: 5,
  },
  legend: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    fontWeight: 'bold',
  },

  //
  formControl: {
    width: 250,
    backgroundColor: '#652020',
    borderRadius: 12,
  },
  select: {
    padding: '14px',
    fontSize: 14,
  },

  outlined: {
    borderRadius: 12,

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#D0D5DD',
    },

    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#7B61FF',
    },

    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#7B61FF',
      borderWidth: 2,
    },
  },

  placeholder: {
    color: '#98A2B3',
  },
};
